import * as Yup from 'yup';

export const overallThresholdSchema = (max: number) => {
    return Yup.object().shape({
        description: Yup.string().required().trim(),
        accept: Yup.number()
            .required()
            .positive()
            .integer()
            .max(max)
            .test('is-not-decimal', 'non-decimal values only', (value) => !!value && value % 1 === 0)
            .label('Threshold')
    });
};

export const scoreThresholdsSchema = Yup.object().shape({
    description: Yup.string().required().trim(),
    accept: Yup.number().max(Yup.ref('reject')).positive().integer().required(),
    reject: Yup.number().min(Yup.ref('accept')).positive().integer().required()
});
